/**
 * AuditSessionDetailLoadingState Component
 *
 * Displays loading state for audit session detail page with header and tab navigation.
 */

import { TabNavigation } from '@core/components/TabNavigation';
import { AuditItemsTab } from '@internal-audit/components/AuditSessionTabNavigation/AuditItemsTab';
import { AuditReportsTab } from '@internal-audit/components/AuditSessionTabNavigation/AuditReportsTab';
import { CommunityAuditDetailHeaderSection } from '@internal-audit/components/CommunityAuditDetailHeaderSection';
import type { FlexibleAuditSession, GraphQLCommunity } from '@internal-audit/domain/graphql-types';

import * as styles from '../AuditSessionDetailPage.css';

interface AuditSessionDetailLoadingStateProps {
  /** Community ID for the audit session */
  communityId: string;
  /** Session ID for the audit session */
  sessionId: string;
  /** Handler for complete audit action */
  onCompleteAudit: () => void;
  /** Handler for delete audit session action */
  onDeleteAuditSession: () => void;
}

export function AuditSessionDetailLoadingState({ communityId, sessionId, onCompleteAudit, onDeleteAuditSession }: AuditSessionDetailLoadingStateProps) {
  return (
    <div>
      {/* Header Section */}
      <div>
        {/* Community Audit Detail Header Section with Loading */}
        <CommunityAuditDetailHeaderSection isLoading auditItems={[]} community={null} session={null} />
      </div>

      {/* Content Section with Solid Background */}
      <div className={styles.contentSection}>
        <div className={styles.contentContainer}>
          {/* Tab Navigation with loading state */}
          <TabNavigation
            ariaLabel="Audit session sections"
            defaultActiveTab="audit-items"
            tabs={[
              {
                key: 'audit-items',
                label: 'Audit Items',
                content: (
                  <AuditItemsTab
                    community={null as unknown as GraphQLCommunity}
                    communityId={communityId}
                    session={null as unknown as FlexibleAuditSession}
                    sessionId={sessionId}
                    onCompleteAudit={onCompleteAudit}
                    onDeleteAuditSession={onDeleteAuditSession}
                  />
                ),
              },
              {
                key: 'reports',
                label: 'Reports',
                disabled: true, // Always disabled during loading state
                disabledTooltip: 'Reports are not available until completion of an audit',
                content: <AuditReportsTab communityId={communityId} sessionId={sessionId} />,
              },
            ]}
          />
        </div>
      </div>
    </div>
  );
}
